/**
 * GymLog domain constants: muscle groups, equipment and timer defaults.
 *
 * Values (`id`) travel over sync and are persisted in DB — NEVER
 * rename them. Display labels are translated in UI layer (lingui).
 */

export const MUSCLE_GROUPS = [
  "chest",
  "back",
  "shoulders",
  "biceps",
  "triceps",
  "forearms",
  "quads",
  "hamstrings",
  "glutes",
  "calves",
  "core",
  "full_body",
] as const;

export type MuscleGroup = (typeof MUSCLE_GROUPS)[number];

export const EQUIPMENT_TYPES = [
  "barbell",
  "dumbbell",
  "machine",
  "cable",
  "bodyweight",
  "kettlebell",
  "band",
  "other",
] as const;

export type EquipmentType = (typeof EQUIPMENT_TYPES)[number];

/** Default rest between sets (if neither exercise nor routine specifies one). */
export const DEFAULT_REST_SECONDS = 90;

/** Increment for "+30s" rest timer button. */
export const REST_TIMER_INCREMENT_SECONDS = 30;

/** Rest selector preset options (seconds). */
export const REST_PRESETS_SECONDS = [30, 60, 90, 120, 180, 240, 300] as const;

/** Valid RPE: 1–10 in steps of 0.5. */
export const RPE_MIN = 1;
export const RPE_MAX = 10;

/** Defensive limit of set history fetched for PRs/charts. */
export const EXERCISE_HISTORY_LIMIT = 2000;

/** Default Olympic barbell weight (kg) for plate calculator. */
export const DEFAULT_BAR_WEIGHT_KG = 20;

/** Common barbell weights offered by plate calculator (kg). */
export const BAR_WEIGHT_OPTIONS_KG = [20, 15, 10] as const;

/**
 * Standard plate denominations (kg), descending. Set assumed by
 * calculator to be available in sufficient quantity per side.
 */
export const STANDARD_PLATES_KG = [25, 20, 15, 10, 5, 2.5, 1.25] as const;
